export default function SvgNotification() {
    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          cursor="pointer"
          fill="black"
          viewBox="0 0 24 24"
        >
          <path d="M10 21h4a2 2 0 01-4 0zm-6.924-2.617a1 1 0 01.217-1.09L5 15.586V10a7.006 7.006 0 016-6.92V2a1 1 0 012 0v1.08A7.006 7.006 0 0119 10v5.586l1.707 1.707A1 1 0 0120 19H4a1 1 0 01-.924-.617zM6.414 17h11.172l-.293-.293A1 1 0 0117 16v-6a5 5 0 00-10 0v6a1 1 0 01-.293.707z"></path>
        </svg>
      </>
    );
  }
  